(function() { module.exports = this["wp"]["autop"]; }());